// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  height: 100%;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100%;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Cluster circles: default plugin CSS supplies fill; add a visible ring */
.leaflet-marker-icon.marker-cluster {
  border: 2px solid rgba(0, 0, 0, 0.45);
  box-sizing: border-box;
}

.leaflet-marker-icon.marker-cluster div {
  border: 2px solid rgba(255, 255, 255, 0.85);
  box-sizing: border-box;
}

/* Chainage interval labels (1 km, 500 m, 250 m, 100 m) */
.leaflet-marker-icon.chainage-interval-marker-leaflet {
  background: transparent;
  border: none;
}

.chainage-interval-marker {
  display: flex;
  align-items: center;
  gap: 4px;
  pointer-events: none;
  white-space: nowrap;
}

.chainage-interval-dot {
  border-radius: 50%;
  border: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);
  flex-shrink: 0;
  pointer-events: auto;
}

.chainage-interval-dot--1km {
  width: 10px;
  height: 10px;
  background: #dc2626;
}

.chainage-interval-dot--500m {
  width: 8px;
  height: 8px;
  background: #16a34a;
}

.chainage-interval-dot--100m {
  width: 7px;
  height: 7px;
  background: #2563eb;
}

.chainage-interval-marker--dot-only {
  gap: 0;
}

.chainage-interval-label {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 4px;
  border: 1px solid;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.3;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;EAGE,YAAY;AACd;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA,0EAA0E;AAC1E;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;AACtB","sourcesContent":["html,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  min-height: 100%;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Cluster circles: default plugin CSS supplies fill; add a visible ring */\n.leaflet-marker-icon.marker-cluster {\n  border: 2px solid rgba(0, 0, 0, 0.45);\n  box-sizing: border-box;\n}\n\n.leaflet-marker-icon.marker-cluster div {\n  border: 2px solid rgba(255, 255, 255, 0.85);\n  box-sizing: border-box;\n}\n\n/* Chainage interval labels (1 km, 500 m, 250 m, 100 m) */\n.leaflet-marker-icon.chainage-interval-marker-leaflet {\n  background: transparent;\n  border: none;\n}\n\n.chainage-interval-marker {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  pointer-events: none;\n  white-space: nowrap;\n}\n\n.chainage-interval-dot {\n  border-radius: 50%;\n  border: none;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.35);\n  flex-shrink: 0;\n  pointer-events: auto;\n}\n\n.chainage-interval-dot--1km {\n  width: 10px;\n  height: 10px;\n  background: #dc2626;\n}\n\n.chainage-interval-dot--500m {\n  width: 8px;\n  height: 8px;\n  background: #16a34a;\n}\n\n.chainage-interval-dot--100m {\n  width: 7px;\n  height: 7px;\n  background: #2563eb;\n}\n\n.chainage-interval-marker--dot-only {\n  gap: 0;\n}\n\n.chainage-interval-label {\n  display: inline-block;\n  padding: 1px 5px;\n  border-radius: 4px;\n  border: 1px solid;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.3;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
